import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import {
  IntegrationsMapping,
  mcpMonitoring,
} from "../../../stack/integrations/IntegrationsMapping";

export const useMCP = () => {
  const { integrations } = useIsIntegrated();
  const availableMCPIntegrations = Object.entries(IntegrationsMapping)
    .filter(([tool, data]) => data.mcpMonitoring === mcpMonitoring.AVAILABLE)
    .map(([tool, data]) => data);

  const upcomingMCPIntegrations = Object.entries(IntegrationsMapping)
    .filter(([tool, data]) => data.mcpMonitoring === mcpMonitoring.UPCOMING)
    .map(([tool, data]) => data);

  const mcpIntegrations = [
    ...availableMCPIntegrations,
    ...upcomingMCPIntegrations,
  ];

  const anyMCPIntegrationRegistered = mcpIntegrations.some((integration) =>
    integrations.includes(integration.codeName)
  );

  return {
    anyMCPIntegrationRegistered,
    availableMCPIntegrations,
    mcpIntegrations,
  };
};
